import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type BasketState = {
	basketSize: number;
};

type BasketActions = {
	setBasketSize: (size: number) => void;
};

type BasketStoreProps = BasketState & BasketActions;

const noopStorage = {
	getItem: () => null,
	setItem: () => undefined,
	removeItem: () => undefined,
};

const getBasketStorage = () => {
	if (typeof window === 'undefined') {
		return noopStorage;
	}

	const storage = window.localStorage as Partial<Storage> | undefined;
	const hasValidStorageApi =
		typeof storage?.getItem === 'function' &&
		typeof storage?.setItem === 'function' &&
		typeof storage?.removeItem === 'function';

	return hasValidStorageApi ? window.localStorage : noopStorage;
};

export const useBasketStore = create<BasketStoreProps>()(
	persist<BasketStoreProps>(
		(set) => ({
			basketSize: 0,
			setBasketSize: (basketSize) => set({ basketSize }),
		}),
		{
			name: 'cfg_basket_store',
			storage: createJSONStorage(getBasketStorage),
			version: 1.1,
			onRehydrateStorage: () => {
				return (_state, error) => {
					if (error) {
						console.log(
							'basket store: error during hydration',
							error
						);
						return;
					}
				};
			},
		}
	)
);
